module.exports = __webpack_public_path__ + "img/swiper.d8acf306.jpg";